import { Box, CircularProgress, Theme, useMediaQuery } from "@mui/material";
import { FC, Suspense, useState } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

import { AuthProvider } from "../auth/AuthContext";
import { ProtectedRoute } from "../auth/ProtectedRoute";
import { Main } from "../components/Main";
import { routeData } from "./routeData";

export const AppRoutes: FC = () => {
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );

  const isLargeScreen = useMediaQuery((theme: Theme) =>
    theme.breakpoints.up("md")
  );

  const onOpenMenu = () => {
    return setIsOpenedMenu(!isOpenedMenu);
  };
  const [isOpenedMenu, setIsOpenedMenu] = useState(false);

  return (
    <AuthProvider>
      <Router>
        <Suspense
          fallback={
            <Box
              alignItems="center"
              display="flex"
              height="100vh"
              justifyContent="center"
              width="100%"
            >
              <CircularProgress />
            </Box>
          }
        >
          <Routes>
            {routeData.map(
              ({
                // borderBottom,
                component: Component,
                header,
                path,
                protected: isProtected,
              }) => (
                <Route
                  element={
                    isProtected ? (
                      <ProtectedRoute>
                        <Main
                          // borderBottom={borderBottom}
                          header={header}
                          isMobile={isMobile}
                          isLargeScreen={isLargeScreen}
                          onOpenMenu={onOpenMenu}
                          isOpenedMenu={isOpenedMenu}
                        >
                          <Component />
                        </Main>
                      </ProtectedRoute>
                    ) : (
                      <Component />
                    )
                  }
                  key={path}
                  path={path}
                />
              )
            )}
          </Routes>
        </Suspense>
      </Router>
    </AuthProvider>
  );
};
